module.exports = __webpack_public_path__ + "static/media/entertainer.e9d33e64.svg";